/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../app/@shared/tracking/navigation-performance-tracking.component.ngfactory';
import * as import2 from '../../app/@shared/tracking/navigation-performance-tracking.component';
import * as import3 from '../../app/@shared/tracking/tracking.service';
import * as import4 from '../../app/@shared/tracking/tracking.config';
import * as import5 from '../app/@shared/tracking/user-timing-tracking.component.ngfactory';
import * as import6 from '../../app/@shared/tracking/user-timing-tracking.component';
import * as import7 from '../app/@shared/tracking/memory-leak-tracking.component.ngfactory';
import * as import8 from '../../app/@shared/tracking/memory-leak-tracking.component';
import * as import9 from '../../app/@shared/tracking/error-tracking.service';
import * as import10 from '../app/@shared/tracking/synthetic-performance-tracking.component.ngfactory';
import * as import11 from '../../app/@shared/tracking/synthetic-performance-tracking.component';
import * as import12 from 'ngx-cookie/src/cookie.service';
import * as import13 from '../../compat/compat-tracking.component';
const styles_CompatTrackingComponent:any[] = ([] as any[]);
export const RenderType_CompatTrackingComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CompatTrackingComponent,
  data: {}
}
);
export function View_CompatTrackingComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-navigation-performance-tracking',([] as any[]),(null as any),(null as any),(null as any),import1.View_NavigationPerformanceTrackingComponent_0,import1.RenderType_NavigationPerformanceTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import2.NavigationPerformanceTrackingComponent,[
      import3.Tracking,
      import4.TRACKING_CONFIG
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-user-timing-tracking',([] as any[]),(null as any),(null as any),(null as any),import5.View_UserTimingTrackingComponent_0,import5.RenderType_UserTimingTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import6.UserTimingTrackingComponent,[import3.Tracking],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-memory-leak-tracking',([] as any[]),(null as any),(null as any),(null as any),import7.View_MemoryLeakTrackingComponent_0,import7.RenderType_MemoryLeakTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import8.MemoryLeakTrackingComponent,[
      import9.ErrorTracking,
      import4.TRACKING_CONFIG
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-synthetic-performance-tracking',([] as any[]),(null as any),(null as any),(null as any),import10.View_SyntheticPerformanceTrackingComponent_0,import10.RenderType_SyntheticPerformanceTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import11.SyntheticPerformanceTrackingComponent,[
      import12.CookieService,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    ck(v,2,0);
    ck(v,5,0);
    ck(v,8,0);
    ck(v,11,0);
  },(null as any));
}
function View_CompatTrackingComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-compat-tracking',([] as any[]),(null as any),(null as any),(null as any),View_CompatTrackingComponent_0,RenderType_CompatTrackingComponent)),
    import0.ɵdid(49152,(null as any),0,import13.CompatTrackingComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CompatTrackingComponentNgFactory:import0.ComponentFactory<import13.CompatTrackingComponent> = import0.ɵccf('app-compat-tracking',import13.CompatTrackingComponent,View_CompatTrackingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC10cmFja2luZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LXRyYWNraW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC10cmFja2luZy5jb21wb25lbnQudHMuQ29tcGF0VHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC10cmFja2luZy5jb21wb25lbnQudHMuQ29tcGF0VHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZmwtbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZz48L2ZsLW5hdmlnYXRpb24tcGVyZm9ybWFuY2UtdHJhY2tpbmc+XG4gICAgPGZsLXVzZXItdGltaW5nLXRyYWNraW5nPjwvZmwtdXNlci10aW1pbmctdHJhY2tpbmc+XG4gICAgPGZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPjwvZmwtbWVtb3J5LWxlYWstdHJhY2tpbmc+XG4gICAgPGZsLXN5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZz48L2ZsLXN5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZz5cbiAgIiwiPGFwcC1jb21wYXQtdHJhY2tpbmc+PC9hcHAtY29tcGF0LXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUNJO2dCQUFBOzs7SUFBQTtLQUFBO0lBQXlFO0lBQ3pFO2dCQUFBO0lBQW1EO0lBQ25EO2dCQUFBOzs7SUFBQTtLQUFBO0lBQW1EO0lBQ25EO2dCQUFBOzs7SUFBQTtLQUFBO0lBQXVFOzs7SUFIdkU7SUFDQTtJQUNBO0lBQ0E7Ozs7O0lDSko7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/compat/compat-tracking.component.ngfactory.ts